export default "__VITE_ASSET__3bfee087__"